import { render, staticRenderFns } from "./EventOld.vue?vue&type=template&id=2cbaaffb&scoped=true"
import script from "./EventOld.vue?vue&type=script&lang=js"
export * from "./EventOld.vue?vue&type=script&lang=js"
import style0 from "./EventOld.vue?vue&type=style&index=0&id=2cbaaffb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbaaffb",
  null
  
)

export default component.exports